module.exports = __webpack_public_path__ + "img/stock5.3c03d3d1.png";